import styled from "styled-components";
import { MainInner } from "@/styles/global";
import { FondCardPadding } from "@/styles/typography";

const RiskWrapper = styled(MainInner)`
    ${FondCardPadding}
`;

const RiskBarWrapper = styled.div`
    max-width: 400px;
    margin: 0 auto;
    position: relative;

    #barContainer {
      width: 100%!important;
      height: auto;
    }
`;

const RiskBarLowLabel = styled.div`
    text-align: left;
    position: absolute;
    left: 38px;
    bottom: -25px;
    font-family: 'Open Sans';
    font-size: 14px;
    color: ${({ theme }) => theme.colors.breadText}
`;

const RiskBarHighLabel = styled.div`
    text-align: right;
    position: absolute;
    right: 38px;
    bottom: -25px;
    font-family: 'Open Sans';
    font-size: 14px;
    color: ${({ theme }) => theme.colors.breadText};
`;

const RiskBarRating = styled.div` 
    position: absolute;
    bottom: -20%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #333;
    text-align: center;
    font-family: Inter;
    font-size: 46px;
`;

const RiskMorningstarRating = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 4em;
`;

const RiskMorningstarRatingTitle = styled.div`
    color: ${({ theme }) => theme.colors.title};
    text-align: center;
    font-family: "PT Serif";
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 10px;
`;

const RiskMorningstarRatingStars = styled.div`
    display: flex;
    align-items: center;

    svg {
        width: 30px;
        height: 30px;
        margin-right: 5px;
    }
`;

const RiskComparisonTitle = styled.div`
    color: ${({ theme }) => theme.colors.title};
    font-family: "PT Serif";
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-align: center;
    margin-top: 2em;
    margin-bottom: 5px;
`;

const RiskSubTitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 1em;
    text-align: center;
    
    color: ${({ theme }) => theme.colors.breadText};
    text-align: center;
    font-family: "Open Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 24px */
`;

const RiskSubTitleHeading = styled.div`

`;

const RiskSubTitleValue = styled.div`
    font-size: 14px;
`;

const S = {
    RiskWrapper,
    RiskBarWrapper,
    RiskBarLowLabel,
    RiskBarHighLabel,
    RiskBarRating,
    RiskMorningstarRating,  
    RiskMorningstarRatingTitle,
    RiskMorningstarRatingStars,
    RiskComparisonTitle,
    RiskSubTitleWrapper,
    RiskSubTitleHeading,
    RiskSubTitleValue
};

export default S;
